import { Navigate } from "react-router-dom";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { PageLoader } from "@/components/PageLoader";

interface Props {
  flag: string;
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * Renders children only when the current user has access to the given feature flag.
 * Otherwise redirects to `redirectTo` (default `/app`).
 */
export function FeatureFlagRoute({ flag, children, redirectTo = "/app" }: Props) {
  const { enabled, loading } = useFeatureFlag(flag);
  if (loading) return <PageLoader />;
  if (!enabled) return <Navigate to={redirectTo} replace />;
  return <>{children}</>;
}
